// The blocklist's unicode fold — THE one definition of "these two strings are the same rule"
// (audit F-26). Shared, dependency-free (browser-safe: the Mini App form bundles it), because
// every surface that READS or WRITES blocklist entries must agree with the matcher or the write
// path drifts into fold-equal duplicates / undeletable entries (F-26's LOW-2): the matcher
// (filters/detect.ts), the /addfilter//delfilter compares, the settings write chokepoint
// (settings/schema.ts), and the Mini App form's dedup key (web/frontend/form.ts).
//
// What the fold does: NFKD compatibility-decomposes styled letters (fullwidth ｓｐａｍ, math-bold
// 𝐬𝐩𝐚𝐦 → spam) and splits accents off their base letters; stripping \p{M} then drops those
// accents AND combining-mark decoration (s̷p̷a̷m̷ → spam — so "spàm" matches "spam",
// accent-INsensitivity is intentional); stripping \p{Cf} removes the invisible-insertion family
// (ZWSP/ZWNJ/ZWJ/word-joiner/soft-hyphen/BOM: s+U+200B+p+… → spam); lowercase last, on the
// decomposed text. Each class is keystone-tested with literal codepoints (filters/detect.test.ts)
// — categories are verified, not assumed. OUT of scope, the documented residual: cross-SCRIPT
// confusables (Cyrillic "а" vs Latin "a") need a confusables table + a false-positive design of
// their own — NFKD does not map confusable LETTERS across scripts (it does fold many compat
// SYMBOLS to ASCII — ™→tm, №→no — which is the same short-token Scunthorpe class as substring
// matching itself).
export function foldForMatch(s: string): string {
  return s.normalize('NFKD').replace(/\p{M}/gu, '').replace(/\p{Cf}/gu, '').toLowerCase()
}

// THE admissibility rule for a blocklist entry's fold, used by every gate: an entry whose fold
// is empty OR whitespace-only can never name real content — as a match needle it degenerates to
// match-EVERYTHING ("anything".includes('') is true; any multi-word message contains " "), so one
// stray pasted invisible ("\u200B", "\u200B \u200B") would silently mass-delete the whole group
// (F-26/HIGH-1, extended to the whitespace class by the session-43 cold-eye). Enforced on the
// WRITE side (settings/schema.ts refine + /addfilter's pre-gate) and mirrored on the READ side
// (matchesBlocklist skips non-matchable needles — a legacy/imported entry must be inert, since
// the lenient read schema deliberately lets it load rather than wipe the chat's config).
export function isMatchableFold(folded: string): boolean {
  return folded.trim().length > 0
}
